// Lycavia-Theme: Verhalten aus shop.js des Prototyps, mit echtem Shopify-Warenkorb.
// Alles hängt an data-Attributen; Daten (Preise, Varianten, Texte) kommen aus Liquid.
// Warenkorb: AJAX-API mit Section Rendering (sections: "korb"), siehe sections/korb.liquid.
(() => {
  const reduziert = matchMedia("(prefers-reduced-motion: reduce)").matches;
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const merken = (speicher, schluessel, wert) => { try { speicher.setItem(schluessel, wert); } catch (e) { /* privater Modus */ } };
  const holen = (speicher, schluessel) => { try { return speicher.getItem(schluessel); } catch (e) { return null; } };
  const vergessen = (speicher, schluessel) => { try { speicher.removeItem(schluessel); } catch (e) { /* privater Modus */ } };
  const body = document.body;
  const wurzel = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";

  // 1 Einblenden beim Scrollen (Texte und Karten)
  const ziele = $$(".einblenden");
  if ("IntersectionObserver" in window) {
    const beobachter = new IntersectionObserver((eintraege) => {
      for (const eintrag of eintraege) {
        if (!eintrag.isIntersecting) continue;
        eintrag.target.classList.add("ist-sichtbar");
        beobachter.unobserve(eintrag.target);
      }
    }, { threshold: 0.25 });
    ziele.forEach((el) => beobachter.observe(el));
  } else {
    ziele.forEach((el) => el.classList.add("ist-sichtbar"));
  }

  // 5 Ebenen: Menü, Warenkorb, Pop-up. Immer nur eine ist offen; Fokus bleibt in der offenen Ebene.
  const schleier = $("[data-schleier]");
  let offen = null;
  let vorherFokus = null;
  const FOKUSSIERBAR = "a[href], button:not([disabled]), input:not([disabled]):not([type='hidden']), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex='-1'])";
  const fokusZiele = (el) => $$(FOKUSSIERBAR, el).filter((x) => x.offsetParent !== null || x === document.activeElement);
  const oeffnen = (el) => {
    if (!el) return;
    if (offen === el) return;
    if (offen) schliessen(offen, false);
    else vorherFokus = document.activeElement;
    offen = el;
    el.hidden = false;
    if (schleier && el.hasAttribute("data-mit-schleier")) schleier.hidden = false;
    void el.offsetWidth; // Startzustand rendern, damit der Übergang läuft
    el.classList.add("ist-offen");
    el.setAttribute("aria-hidden", "false");
    if (schleier && el.hasAttribute("data-mit-schleier")) schleier.classList.add("ist-offen");
    body.classList.add("ist-gesperrt");
    const fokus = $("[data-fokus]", el) || el;
    fokus.focus({ preventScroll: true });
  };
  const schliessen = (el = offen, fokusZurueck = true) => {
    if (!el || !el.classList.contains("ist-offen")) return;
    el.classList.remove("ist-offen");
    el.setAttribute("aria-hidden", "true");
    if (schleier) schleier.classList.remove("ist-offen");
    setTimeout(() => {
      if (!el.classList.contains("ist-offen")) el.hidden = true;
      if (schleier && !schleier.classList.contains("ist-offen")) schleier.hidden = true;
    }, 450);
    if (offen === el) offen = null;
    if (!offen) body.classList.remove("ist-gesperrt");
    if (fokusZurueck && vorherFokus && vorherFokus.isConnected && vorherFokus.focus) vorherFokus.focus({ preventScroll: true });
    el.dispatchEvent(new CustomEvent("geschlossen"));
  };
  addEventListener("keydown", (e) => {
    if (!offen) return;
    if (e.key === "Escape") { schliessen(); return; }
    if (e.key !== "Tab") return;
    const liste = fokusZiele(offen);
    if (!liste.length) { e.preventDefault(); offen.focus(); return; }
    const erstes = liste[0];
    const letztes = liste[liste.length - 1];
    if (e.shiftKey && (document.activeElement === erstes || document.activeElement === offen)) { e.preventDefault(); letztes.focus(); }
    else if (!e.shiftKey && document.activeElement === letztes) { e.preventDefault(); erstes.focus(); }
  });
  if (schleier) schleier.addEventListener("click", () => schliessen());

  // 6 Handy-Menü
  const menue = $("#menue");
  if (menue) {
    $$("[data-menue-oeffnen]").forEach((b) => b.addEventListener("click", () => oeffnen(menue)));
    $$("[data-menue-schliessen]", menue).forEach((b) => b.addEventListener("click", () => schliessen(menue)));
    $$("a", menue).forEach((a) => a.addEventListener("click", () => { if (!a.hasAttribute("data-popup-oeffnen")) schliessen(menue, false); }));
  }

  // 7 Mengenfelder (+ und −), auch im Warenkorb
  const mengeSetzen = (feld, wert) => {
    const min = Number(feld.min || 1);
    const max = Number(feld.max || 10);
    feld.value = String(Math.min(max, Math.max(min, Number.isFinite(wert) ? wert : min)));
    feld.dispatchEvent(new Event("change", { bubbles: true }));
  };
  document.addEventListener("click", (e) => {
    const knopf = e.target.closest("[data-menge-minus], [data-menge-plus]");
    if (!knopf) return;
    const feld = $("input", knopf.closest(".menge"));
    if (feld) mengeSetzen(feld, Number(feld.value) + (knopf.hasAttribute("data-menge-plus") ? 1 : -1));
  });

  // 8 Warenkorb: Shopify AJAX-API, Panel und Warenkorbseite kommen als fertiges HTML zurück
  const korb = $("#korb");
  const korbInhalt = korb && $("[data-korb-inhalt]", korb);
  const sektionen = () => {
    const ids = ["korb"];
    $$("[data-warenkorb-seite][data-sektion-id]").forEach((el) => ids.push(el.dataset.sektionId));
    return ids;
  };
  const anzahlSetzen = (anzahl) => {
    $$("[data-korb-anzahl]").forEach((el) => { el.textContent = String(anzahl); el.hidden = anzahl === 0; });
  };
  const fehlerText = (daten) => (daten && (daten.description || daten.message)) || "Das hat leider nicht geklappt. Bitte versuch es noch einmal.";
  const korbFehler = (text) => {
    const ziel = korb && $("[data-kauf-fehler]", korb);
    if (ziel) { ziel.textContent = text; ziel.hidden = false; }
  };
  // Neues HTML einsetzen. Versandbalken wächst vom alten Stand aus, Fokus bleibt an gleicher Stelle.
  const korbZeichnen = (html) => {
    if (!html) return;
    if (html.korb && korbInhalt) {
      const alterBalken = $("[data-versand-balken]", korbInhalt);
      const alteBreite = alterBalken ? alterBalken.style.width : "";
      const aktiv = document.activeElement;
      const fokusStelle = korb.contains(aktiv) && korbInhalt.contains(aktiv) ? fokusZiele(korbInhalt).indexOf(aktiv) : -1;
      korbInhalt.innerHTML = html.korb;
      const neuerBalken = $("[data-versand-balken]", korbInhalt);
      if (neuerBalken && alteBreite && !reduziert) {
        const ziel = neuerBalken.style.width;
        neuerBalken.style.width = alteBreite;
        void neuerBalken.offsetWidth;
        neuerBalken.style.width = ziel;
      }
      if (fokusStelle >= 0) {
        const liste = fokusZiele(korbInhalt);
        const ziel = liste[Math.min(fokusStelle, liste.length - 1)];
        (ziel || $("[data-korb-schliessen]", korb)).focus({ preventScroll: true });
      }
      const stand = $("[data-korb-stand]", korbInhalt);
      if (stand) anzahlSetzen(Number(stand.dataset.korbStand) || 0);
    }
    Object.keys(html).filter((id) => id !== "korb" && html[id]).forEach((id) => {
      const alt = document.getElementById(`shopify-section-${id}`);
      if (alt) alt.outerHTML = html[id];
    });
  };
  // Anfragen nacheinander, damit Zeilennummern und Mengen stimmen
  let warteschlange = Promise.resolve();
  const korbAnfrage = (pfad, daten) => {
    const lauf = warteschlange.then(async () => {
      const ist = daten instanceof FormData;
      if (ist) { daten.append("sections", sektionen().join(",")); daten.append("sections_url", location.pathname); }
      else daten = { ...daten, sections: sektionen(), sections_url: location.pathname };
      $$(".korb-panel__inhalt, [data-warenkorb-seite]").forEach((el) => el.setAttribute("aria-busy", "true"));
      try {
        const antwort = await fetch(`${wurzel}${pfad}`, {
          method: "POST",
          headers: ist ? { Accept: "application/json" } : { "Content-Type": "application/json", Accept: "application/json" },
          body: ist ? daten : JSON.stringify(daten),
        });
        const json = await antwort.json().catch(() => null);
        if (!antwort.ok || !json || json.status) throw new Error(fehlerText(json));
        korbZeichnen(json.sections);
        return json;
      } finally {
        $$("[aria-busy='true']").forEach((el) => el.removeAttribute("aria-busy"));
      }
    });
    warteschlange = lauf.catch(() => {});
    return lauf;
  };

  if (korb) {
    $$("[data-korb-oeffnen]").forEach((b) => b.addEventListener("click", () => oeffnen(korb)));
    $$("[data-korb-schliessen]", korb).forEach((b) => b.addEventListener("click", () => schliessen(korb)));
  }

  // Menge einer Zeile ändern (Panel und Warenkorbseite), kurz gesammelt bei schnellem Klicken
  const zeilenUhr = {};
  const zeileSetzen = (zeile, menge) => korbAnfrage("cart/change.js", { line: Number(zeile), quantity: Math.max(0, menge || 0) })
    .catch((fehler) => korbFehler(fehler.message));
  document.addEventListener("change", (e) => {
    const feld = e.target.closest("[data-korb-zeile]");
    if (!feld) return;
    const zeile = feld.dataset.korbZeile;
    clearTimeout(zeilenUhr[zeile]);
    zeilenUhr[zeile] = setTimeout(() => zeileSetzen(zeile, Number(feld.value)), 350);
  });
  document.addEventListener("click", (e) => {
    const weg = e.target.closest("[data-korb-entfernen]");
    if (weg) {
      e.preventDefault();
      clearTimeout(zeilenUhr[weg.dataset.korbEntfernen]);
      zeileSetzen(weg.dataset.korbEntfernen, 0);
      return;
    }
    // Staffel-Hinweis: Einzeldosen gegen das Paket tauschen
    const staffel = e.target.closest("[data-staffel-variante]");
    if (!staffel) return;
    const updates = {
      [staffel.dataset.staffelEinzel]: Number(staffel.dataset.staffelRest) || 0,
      [staffel.dataset.staffelVariante]: Number(staffel.dataset.staffelMenge) || 1,
    };
    staffel.disabled = true;
    korbAnfrage("cart/update.js", { updates }).catch((fehler) => { staffel.disabled = false; korbFehler(fehler.message); });
  });

  // In den Warenkorb: Karten mit Varianten-ID, im Kaufbereich die gewählte Packung und Menge.
  // Gratis-Beigabe: der Kaufknopf (auch in der Kaufleiste) legt die gewählte Beigabe mit _beigabe dazu,
  // Knöpfe mit data-beigabe-knopf legen ihre Variante als Beigabe. Höchstens eine Beigabe im Warenkorb.
  let beigabeUnterwegs = false;
  const hatBeigabe = () => beigabeUnterwegs || !!document.querySelector("[data-korb-beigabe]");
  document.addEventListener("click", (e) => {
    const knopf = e.target.closest("[data-in-den-korb]");
    if (!knopf || knopf.disabled) return;
    e.preventDefault();
    const bereich = knopf.closest("[data-kaufbereich]");
    const istBeigabeKnopf = knopf.hasAttribute("data-beigabe-knopf");
    if (istBeigabeKnopf && hatBeigabe()) return;
    let id = knopf.dataset.inDenKorb;
    let menge = 1;
    const ausBereich = !id && !!bereich;
    if (ausBereich) {
      const gewaehlt = $("input[name='id']:checked", bereich) || $("input[type='hidden'][name='id'], select[name='id']", bereich);
      id = gewaehlt && gewaehlt.value;
      const feld = $("[data-menge-feld]", bereich);
      menge = feld ? Number(feld.value) || 1 : 1;
    }
    if (!id) return;
    const items = [{ id: Number(id), quantity: menge }];
    if (istBeigabeKnopf) items[0].properties = { _beigabe: "1" };
    const beigabe = ausBereich && $("[data-beigabe]", bereich);
    const geschenk = beigabe && !beigabe.hidden && $("input[name='beigabe']:checked", beigabe);
    if (geschenk && geschenk.value && !hatBeigabe()) {
      items.push({ id: Number(geschenk.value), quantity: 1, properties: { _beigabe: "1" } });
    }
    const mitBeigabe = items.some((posten) => posten.properties);
    if (mitBeigabe) beigabeUnterwegs = true;
    const meldung = (bereich && $("[data-kauf-fehler]", bereich)) || null;
    // Auf der Warenkorbseite nicht zusätzlich das Panel öffnen: die Seite zeigt den Warenkorb schon.
    const ausSeite = !!knopf.closest("[data-warenkorb-seite]");
    if (meldung) { meldung.textContent = ""; meldung.hidden = true; }
    knopf.disabled = true;
    knopf.setAttribute("aria-busy", "true");
    korbAnfrage("cart/add.js", { items })
      .then(() => { if (korb && !ausSeite && !korb.contains(knopf)) oeffnen(korb); })
      .catch((fehler) => {
        if (meldung) { meldung.textContent = fehler.message; meldung.hidden = false; }
        else { korbFehler(fehler.message); if (korb && !korb.contains(knopf)) oeffnen(korb); }
      })
      .finally(() => {
        if (mitBeigabe) beigabeUnterwegs = false;
        if (knopf.isConnected) { knopf.disabled = false; knopf.removeAttribute("aria-busy"); }
      });
  });

  // 9 Packungswahl: Preis, Statt-Preis, Preis pro Tag, Grundpreis, Bild und Beigabe folgen der gewählten Variante.
  //   Die Adresse (?variant=) ändert sich nur auf Produktseiten (data-adresse am Kaufbereich).
  $$("[data-packungen]").forEach((gruppe) => {
    const bereich = gruppe.closest("[data-kaufbereich]") || document;
    const adresse = !!gruppe.closest("[data-adresse]");
    const anzeige = $("[data-packung-preis]", bereich);
    const statt = $("[data-packung-statt]", bereich);
    const tagespreis = $("[data-packung-tagespreis]", bereich);
    const grund = $("[data-packung-grundpreis]", bereich);
    const bild = $("[data-packung-bild]", bereich);
    const beigabe = $("[data-beigabe]", bereich);
    const zeigen = (adresseSetzen) => {
      const wahl = $("input[type='radio'][name='id']:checked", gruppe);
      if (!wahl) return;
      const d = wahl.dataset;
      if (anzeige && d.preis !== undefined) anzeige.textContent = d.preis;
      if (statt) { statt.textContent = d.statt || ""; statt.hidden = !d.statt; }
      if (tagespreis && d.tagespreis !== undefined) { tagespreis.textContent = d.tagespreis; tagespreis.hidden = !d.tagespreis; }
      if (grund && d.grundpreis !== undefined) grund.textContent = d.grundpreis;
      if (beigabe) beigabe.hidden = Number(d.dosen || 1) < Number(beigabe.dataset.ab || 2);
      if (bild && d.bild && bild.getAttribute("src") !== d.bild) {
        bild.removeAttribute("srcset");
        bild.removeAttribute("sizes");
        bild.src = d.bild;
      }
      if (d.verfuegbar !== undefined) {
        $$("[data-in-den-korb]", bereich).forEach((k) => { if (!k.dataset.inDenKorb) k.disabled = d.verfuegbar === "false"; });
      }
      if (adresseSetzen && adresse) {
        const url = new URL(location.href);
        url.searchParams.set("variant", wahl.value);
        history.replaceState(history.state, "", url);
      }
    };
    gruppe.addEventListener("change", () => zeigen(true));
    zeigen(false); // Browser kann beim Zurückgehen eine andere Auswahl wiederherstellen
  });

  // 10 Filter der Shop-Übersicht (?filter=zubehoer wählt vor)
  const filter = $("[data-filter]");
  if (filter) {
    const knoepfe = $$("button[value]", filter);
    const setzen = (gewuenscht) => {
      const art = knoepfe.some((b) => b.value === gewuenscht) ? gewuenscht : "alle";
      knoepfe.forEach((b) => b.setAttribute("aria-pressed", String(b.value === art)));
      $$("[data-art]").forEach((karte) => { karte.hidden = art !== "alle" && karte.dataset.art !== art; });
    };
    filter.addEventListener("click", (e) => { const b = e.target.closest("button[value]"); if (b) setzen(b.value); });
    setzen(new URLSearchParams(location.search).get("filter"));
  }

  // 11 Gutschein: Vorschau folgt dem Formular, danach als Shopify-Geschenkgutschein mit Empfängerdaten in den Warenkorb.
  //    Empfängerfelder nach https://shopify.dev/docs/storefronts/themes/product-merchandising/gift-cards
  const gForm = $("form[data-gutschein-form]");
  if (gForm) {
    const v = (name) => $$(`[data-v="${name}"]`);
    const schreiben = (name, text) => v(name).forEach((el) => { el.textContent = text; });
    const jetzt = new Date();
    const heute = new Date(jetzt.getTime() - jetzt.getTimezoneOffset() * 60000).toISOString().slice(0, 10);
    const feld = (name) => gForm.querySelector(`[name="${name}"]`);
    const wert = (name) => { const f = feld(name); return f ? f.value.trim() : ""; };
    const email = feld("email");
    const datum = feld("datum");
    const nachricht = feld("nachricht");
    const grenze = nachricht && nachricht.maxLength > 0 ? nachricht.maxLength : 200;
    if (datum) datum.min = heute;
    const fehler = (f, text) => {
      if (!f) return;
      const meldung = $(`[data-fehler-fuer="${f.name}"]`, gForm);
      f.classList.toggle("ist-fehler", !!text);
      f.setAttribute("aria-invalid", text ? "true" : "false");
      if (meldung) { meldung.textContent = text; meldung.hidden = !text; }
    };
    const zeigen = () => {
      const betrag = $("input[name='id']:checked", gForm);
      const betragText = betrag ? betrag.dataset.betrag || "" : "";
      const an = wert("an");
      const von = wert("von");
      schreiben("betrag", betragText);
      schreiben("an", an ? `Für ${an}` : "Für dich");
      schreiben("nachricht", wert("nachricht") || "Hier steht deine Nachricht.");
      schreiben("von", von ? `Von ${von}` : "");
      $$("[data-gutschein-preis]").forEach((el) => { el.textContent = betragText; });
      const zaehler = $("[data-zaehler]", gForm);
      if (zaehler && nachricht) zaehler.textContent = `${nachricht.value.length}/${grenze}`;
    };
    gForm.addEventListener("input", (e) => { if (e.target.classList.contains("ist-fehler")) fehler(e.target, ""); zeigen(); });
    gForm.addEventListener("change", zeigen);
    gForm.addEventListener("submit", (e) => {
      e.preventDefault();
      const emailOk = !!email && /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email.value.trim());
      const datumOk = !datum || !datum.value || datum.value >= heute;
      fehler(email, emailOk ? "" : "Bitte gib die E-Mail-Adresse der beschenkten Person ein.");
      fehler(datum, datumOk ? "" : "Bitte wähle heute oder einen Tag in der Zukunft.");
      if (!emailOk || !datumOk) { (emailOk ? datum : email).focus(); return; }
      const zeitzone = $("[data-zeitzone]", gForm);
      if (zeitzone) zeitzone.value = String(new Date().getTimezoneOffset());
      const d = new FormData(gForm);
      const zuordnung = { email: "Recipient email", an: "Recipient name", nachricht: "Message", datum: "Send on", von: "Von" };
      Object.entries(zuordnung).forEach(([roh, eigenschaft]) => {
        const inhalt = (d.get(roh) || "").toString().trim();
        d.delete(roh);
        if (inhalt) d.set(`properties[${eigenschaft}]`, inhalt);
      });
      const knopf = $("[type='submit']", gForm);
      const meldung = $("[data-kauf-fehler]", gForm);
      if (meldung) { meldung.textContent = ""; meldung.hidden = true; }
      if (knopf) knopf.disabled = true;
      korbAnfrage("cart/add.js", d)
        .then(() => { gForm.reset(); if (datum) datum.min = heute; zeigen(); oeffnen(korb); })
        .catch((f) => { if (meldung) { meldung.textContent = f.message; meldung.hidden = false; } else { korbFehler(f.message); oeffnen(korb); } })
        .finally(() => { if (knopf) knopf.disabled = false; });
    });
    zeigen();
  }

  // 12 Newsletter im Fuß: echtes Shopify-Kundenformular. Quelle merken, damit nach dem Neuladen
  //    nur das richtige Formular seine Erfolgsmeldung zeigt (Shopify meldet Erfolg für alle Kundenformulare).
  const quelle = holen(sessionStorage, "newsletter-quelle");
  vergessen(sessionStorage, "newsletter-quelle");
  $$("form[data-news-form]").forEach((form) => {
    form.addEventListener("submit", () => merken(sessionStorage, "newsletter-quelle", "fuss"));
    if (quelle === "popup") {
      const erfolg = $("[data-news-erfolg]", form);
      if (erfolg && erfolg.dataset.newsStandard) { erfolg.textContent = erfolg.dataset.newsStandard; erfolg.removeAttribute("data-news-erfolg"); }
      const fehlerZeile = $("[data-news-fehler]", form);
      if (fehlerZeile) fehlerZeile.hidden = true;
    }
  });

  // 13 Rabatt-Pop-up mit Shopify-Kundenformular (Tags newsletter, rabatt)
  const popup = $("#popup");
  const lasche = $("[data-rabatt-lasche]");
  const schrittZeigen = (nummer) => {
    $("[data-popup-schritt='1']", popup).hidden = nummer !== 1;
    $("[data-popup-schritt='2']", popup).hidden = nummer !== 2;
  };
  document.addEventListener("click", (e) => {
    const ausloeser = e.target.closest("[data-popup-oeffnen]");
    if (!ausloeser || !popup) return; // ohne Pop-up führt #newsletter zum Formular im Fuß
    e.preventDefault();
    if (holen(localStorage, "rabatt-angemeldet") === "1") schrittZeigen(2);
    if (lasche) lasche.classList.remove("ist-sichtbar");
    oeffnen(popup);
  });
  if (popup) {
    const angemeldet = () => holen(localStorage, "rabatt-angemeldet") === "1";
    const laschePruefen = () => { if (lasche) lasche.classList.toggle("ist-sichtbar", !angemeldet() && !popup.classList.contains("ist-offen")); };
    const form = $("form[data-popup-form]", popup);
    const feld = form && $("input[type='email']", form);
    const fehlerZeile = form && $("[data-popup-fehler]", form);

    $$("[data-popup-schliessen]", popup).forEach((b) => b.addEventListener("click", () => schliessen(popup)));
    popup.addEventListener("click", (e) => { if (e.target === popup) schliessen(popup); });
    popup.addEventListener("geschlossen", () => setTimeout(laschePruefen, 500));
    if (lasche) lasche.addEventListener("click", () => { lasche.classList.remove("ist-sichtbar"); oeffnen(popup); });

    // Nach dem Absenden lädt Shopify die Seite neu; Liquid setzt dann data-popup-sofort (erfolg oder fehler)
    let sofort = popup.dataset.popupSofort || "";
    if (sofort && quelle === "fuss") {
      // Die Meldung gehört zum Fuß-Formular: Pop-up bleibt im Ausgangszustand
      if (!angemeldet()) schrittZeigen(1);
      if (fehlerZeile) fehlerZeile.hidden = true;
      if (feld) feld.classList.remove("ist-fehler");
      sofort = "";
    }
    if (sofort === "erfolg") merken(localStorage, "rabatt-angemeldet", "1");

    if (sofort) {
      merken(sessionStorage, "popup-gesehen", "1");
      oeffnen(popup);
      const ziel = sofort === "erfolg" ? $("[data-code-kopieren]", popup) : feld;
      if (ziel) ziel.focus({ preventScroll: true });
    } else if (!angemeldet() && holen(sessionStorage, "popup-gesehen") !== "1") {
      // Zeit oder Scrolltiefe, je nachdem was zuerst eintritt. Danach sind beide Auslöser weg.
      let uhr = 0;
      const beiScroll = () => { if (scrollY >= document.documentElement.scrollHeight * 0.3) ausloesen(); };
      const ausloesen = () => {
        clearTimeout(uhr);
        removeEventListener("scroll", beiScroll);
        if (offen || angemeldet()) return;
        merken(sessionStorage, "popup-gesehen", "1");
        if (lasche) lasche.classList.remove("ist-sichtbar");
        oeffnen(popup);
      };
      uhr = setTimeout(ausloesen, 7000);
      addEventListener("scroll", beiScroll, { passive: true });
    } else {
      laschePruefen();
    }

    if (form && feld) {
      form.addEventListener("submit", (e) => {
        const gueltig = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(feld.value.trim());
        feld.classList.toggle("ist-fehler", !gueltig);
        if (fehlerZeile) fehlerZeile.hidden = gueltig;
        if (!gueltig) { e.preventDefault(); feld.focus(); return; }
        merken(sessionStorage, "newsletter-quelle", "popup");
      });
      feld.addEventListener("input", () => { if (feld.classList.contains("ist-fehler")) { feld.classList.remove("ist-fehler"); if (fehlerZeile) fehlerZeile.hidden = true; } });
    }
    const kopieren = $("[data-code-kopieren]", popup);
    if (kopieren) kopieren.addEventListener("click", () => {
      const code = $("[data-code]", popup).textContent.trim();
      const fertig = () => { kopieren.textContent = "Kopiert"; setTimeout(() => { kopieren.textContent = "Kopieren"; }, 2000); };
      if (navigator.clipboard) navigator.clipboard.writeText(code).then(fertig).catch(fertig); else fertig();
    });
  }

  // 14 Schiebeleisten (Momente, Regal): Pfeile zum Weiterblättern
  $$("[data-spur]").forEach((spur) => {
    if (!spur.id) return;
    const weite = () => Math.max(260, spur.clientWidth * 0.7);
    $$(`[data-spur-zurueck="${spur.id}"]`).forEach((b) => b.addEventListener("click", () => spur.scrollBy({ left: -weite(), behavior: reduziert ? "auto" : "smooth" })));
    $$(`[data-spur-vor="${spur.id}"]`).forEach((b) => b.addEventListener("click", () => spur.scrollBy({ left: weite(), behavior: reduziert ? "auto" : "smooth" })));
  });
})();
